import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"PT_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"style\":[\"normal\",\"italic\"],\"display\":\"optional\",\"variable\":\"--font-pt-sans\",\"preload\":true}],\"variableName\":\"ptSans\"}");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/calendar.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppShellWrapper"] */ "/workspace/src/components/app-shell-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/src/context/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DebugProvider"] */ "/workspace/src/context/debug-context.tsx");
